import React from 'react';
import { openMcpOAuthPopup, subscribeMcpOAuthPostMessage } from '../../utils/mcpOAuth';

/** Unified human gate — write permission or MCP OAuth sign-in. */
export default function UserGateBar({ props: p, onAction, partId, disabled, dir }) {
  const gateKind = p.gate_kind
    || (p.authorization_url || p.authorizationUrl ? 'oauth_connect' : 'write_confirm');
  const isOAuth = gateKind === 'oauth_connect';

  const summary = p.summary || p.title || (isOAuth ? 'Sign in to continue' : 'Allow this action?');
  const detail = p.detail || p.description;
  const authorizationUrl = p.authorization_url || p.authorizationUrl;
  const serverId = p.mcp_server_id ?? p.mcpServerId;

  const fire = (actionId, { alwaysAllow = false, resumePendingTool = false } = {}) => {
    onAction?.({
      actionId,
      mode: actionId === 'write.deny' || actionId === 'write.cancel' || actionId === 'oauth.cancel' ? 'patch' : 'turn',
      payload: { tool_name: p.tool_name, mcp_server_id: serverId },
      partId,
      alwaysAllowWrite: alwaysAllow,
      resumePendingTool,
    });
  };

  const handleOAuthSignIn = () => {
    if (!authorizationUrl) {
      fire('oauth.cancel');
      return;
    }
    const unsubscribe = subscribeMcpOAuthPostMessage((data) => {
      if (String(data.serverId || '') !== String(serverId || '')) return;
      unsubscribe();
      if (data.status === 'ok') {
        fire('oauth.continue', { resumePendingTool: true });
      }
    });
    openMcpOAuthPopup(authorizationUrl, {
      serverId,
      onClosedWithoutSuccess: () => unsubscribe(),
    });
  };

  if (isOAuth) {
    return (
      <div className="ui-write-permission" dir={dir} role="group" aria-label="Connector sign-in">
        <div className="ui-write-permission__text">
          <span className="ui-write-permission__summary">{summary}</span>
          {detail ? <span className="ui-write-permission__detail">{detail}</span> : null}
        </div>
        <div className="ui-write-permission__actions">
          <button
            type="button"
            className="ui-btn primary"
            disabled={disabled || !authorizationUrl}
            onClick={handleOAuthSignIn}
          >
            Sign in
          </button>
          <button type="button" className="ui-btn secondary" disabled={disabled} onClick={() => fire('oauth.cancel')}>
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ui-write-permission" dir={dir} role="group" aria-label="Tool permission">
      <div className="ui-write-permission__text">
        <span className="ui-write-permission__summary">{summary}</span>
        {detail ? <span className="ui-write-permission__detail">{detail}</span> : null}
      </div>
      <div className="ui-write-permission__actions">
        <button
          type="button"
          className="ui-btn primary"
          disabled={disabled}
          onClick={() => fire('write.confirm', { resumePendingTool: true })}
        >
          Allow
        </button>
        <button type="button" className="ui-btn secondary" disabled={disabled} onClick={() => fire('write.deny')}>
          Deny
        </button>
        <button
          type="button"
          className="ui-btn ui-btn--link"
          disabled={disabled}
          onClick={() => fire('write.always_allow', { alwaysAllow: true, resumePendingTool: true })}
        >
          Always allow
        </button>
      </div>
    </div>
  );
}
